/* unplugin-vue-components disabled */import script from "./Incident.vue?vue&type=script&lang=ts&setup=true"
export * from "./Incident.vue?vue&type=script&lang=ts&setup=true"

import "./Incident.vue?vue&type=style&index=0&id=38e1e32b&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38e1e32b"]])

export default __exports__